
import { batchDownload } from '~/plugins/batch-download'
import {
  // downloadFile,
  downloadImage
} from '@/utils/common'

export default {
  name: 'BatchDownload',
  data() {
    return {
      Downtop: 85,
      Downleft: 20,
      json: [],
      size: 300,
      zipFileList: [],
      pic_title: '',
      batchSn: '',
      list: []
    }
  },
  beforeDestroy() {
    //this.$resize.remove(this.downloadHanldeResize)
  },
  mounted() {
    batchDownload.$on('batchDownload', this.download)
    this.downloadHanldeResize()
    //this.$resize.add(this.downloadHanldeResize)
  },
  computed: {
  },
  methods: {
    downloadHanldeResize() {
      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight
      )
      const documentWidth = Math.max(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.body.clientWidth,
        document.documentElement.clientWidth
      )
      this.maxHeight = documentHeight - 61
      this.maxWidth = documentWidth - 250
      this.Downleft = this.maxWidth - 30
    },
    onMouseDown(event) {
      this.$refs.batchDownloadRef.style.cursor = 'grabbing'
      // 开始拖拽时记录鼠标初始位置
      this.isDragging = true
      this.startX = event.clientX - this.Downleft
      this.startY = event.clientY - this.Downtop

      // 添加鼠标移动和松开事件监听
      document.addEventListener('mousemove', this.onMouseMove)
      document.addEventListener('mouseup', this.onMouseUp)
    },
    onMouseMove(event) {
      // 计算新的位置
      if (this.isDragging) {
        const moeveLeft = event.clientX - this.startX
        const moeveTop = event.clientY - this.startY

        this.initDownLeft(moeveLeft)
        this.initDownTop(moeveTop)
        this.moveLog = true
      }
    },
    onMouseUp() {
      // 停止拖拽
      this.isDragging = false
      // 移除事件监听
      document.removeEventListener('mousemove', this.onMouseMove)
      document.removeEventListener('mouseup', this.onMouseUp)
      this.$refs.batchDownloadRef.style.cursor = 'grab'

      if (this.moveLog) {
        // this.$picApi.userColorSelect(this.colorLeft, this.colorTop).then()
        this.moveLog = false
      }
    },
    startMap(event) {
      if (event.touches && event.touches.length === 1) {
        // 开始拖拽时记录鼠标初始位置
        this.isDragging = true
        this.startX = event.touches[0].pageX - this.Downleft
        this.startY = event.touches[0].pageY - this.Downtop
        document.addEventListener('touchmove', this.moveMap)
        document.addEventListener('touchend', this.moveEnd)
      }
    },
    moveMap(event) {
      // 计算新的位置
      if (this.isDragging) {
        const moeveLeft = event.touches[0].pageX - this.startY
        const moeveTop = event.touches[0].pageY - this.startX
        this.initDownLeft(moeveLeft)
        this.initDownTop(moeveTop)
        this.moveLog = true
      }
    },
    moveEnd(event) {
      // 停止拖拽
      this.isDragging = false
      // 移除事件监听
      document.removeEventListener('touchmove', this.moveMap)
      document.removeEventListener('touchend', this.moveEnd)

      if (this.moveLog) {
        //this.$picApi.userColorSelect(this.colorLeft, this.colorTop).then()
        this.moveLog = false
      }
    },
    initDownLeft(moeveLeft) {
      if (moeveLeft > 0) {
        if (moeveLeft > this.maxWidth) {
          this.Downleft = this.maxWidth
        } else {
          this.Downleft = moeveLeft
        }
      } else {
        this.Downleft = 0
      }
    },
    initDownTop(moeveTop) {
      if (moeveTop > 0) {
        if (moeveTop > this.maxHeight) {
          this.Downtop = this.maxHeight
        } else {
          this.Downtop = moeveTop
        }
      } else {
        this.Downtop = 0
      }
    },
    download(data) {
      this.list = this.list.concat(data.list)
      console.log(this.list)
      this.startText = '执行中'
      if (!this.isStart) {
        this.isStart = true
        this.startDown()
      }

    },
    startChange() {
      if (this.startValue === 1) {
        this.startText = '已暂停'
        this.isStart = false
      } else if (this.startValue === 2) {
        this.startText = '执行中'
        this.isStart = true
        this.startDown()
      } else if (this.startValue === 3) {
        this.list = []
      }
    },
    start() {
      this.value = ''
      let element = this.$refs['start-select']
      if (element) {
        element[0].selectOption()
      }
    },

    startDown() {
      if (!this.isStart) {
        return false
      }
      if (this.list.length === 0) {
        this.isStart = false
        return false
      }
      this.downloadImg(this.list[0])
    },

    deleteDown(index) {
      this.list.splice(index, 1)
      this.startDown()
    },

    // 下载图片
    downloadImg(item) {
      downloadImage(item.url, item.title).then(() => {
        this.deleteDown(0)
      })

    },
  },
}
